import { render } from "./NThemeImage.vue?vue&type=template&id=c8648036&ts=true"
import script from "./NThemeImage.vue?vue&type=script&lang=ts"
export * from "./NThemeImage.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__